<template>
    <section v-show="!!tour.brandCard && !!tour.brandCard.name" class="brand-card-section">
        <div class="logo" :style="{backgroundImage: `url(${tour.brandCard.logo})`}"></div>
        <div class="desc" >{{ tour.brandCard.brandDescription }}</div>
    </section>
</template>

<script>
export default {
    name: 'TourBrandCard',
    props: {
        tour: {
            type: Object,
            required: true
        }
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/sass/_mixins.scss';
    @import '../../../assets/sass/_variables.scss';
    .brand-card-section{
        width: 100%;
        min-height: 130px;
        display: flex;
        flex-direction: row;
        background: #F7F7F7;
        border-radius: 24px;
        margin-bottom: 30px;
        box-shadow: 0px 40px 32px -24px rgba(15,15,15,0.12);
        .logo{
            flex-basis: 25%;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 80%;
        }
        .desc{
            flex-basis: 75%;
            padding: 25px;
            font-weight: 400;
            font-size: 16px !important;
            line-height: 1.4 !important;
        }
    }
    @include max-width($tablet) {
        .brand-card-section{
            padding-top: 0px;
            .desc{
                font-size: 14px !important;
            }
        }
    }
    @include max-width($mobile) {
        .brand-card-section{
            flex-direction: column;
            box-shadow: none;
            height: 230px;
            .logo{
                flex-basis: 60%;
                background-size: 25%;
            }
            .desc{
                flex-basis: 40%;
                padding: 0px 20px 10px 20px;
                margin-top: -10px;
            }
        }
    }

</style>
